/**
 * demoFirestoreGuard.ts — Firestore Network Guard
 *
 * Catches accidental Firestore reads/writes in demo mode.
 *
 * Place at: src/demo/demoFirestoreGuard.ts
 */

import { isDemoMode } from './demoState';

export function assertNotDemo(operation: string): void {
  if (isDemoMode()) {
    throw new Error(
      `[DemoGuard] Firestore "${operation}" blocked in demo mode. ` +
        `Demo data should come from src/demo/demoData.ts, not Firestore.`,
    );
  }
}
